// extracted by mini-css-extract-plugin
export default {"container":"Location_container__0MSCK","content":"Location_content__-5meL","left":"Location_left__6+F1M","button":"Location_button__ANm6P"};